import { render } from "./SampleWells.vue?vue&type=template&id=33b0f016"
import script from "./SampleWells.vue?vue&type=script&lang=js"
export * from "./SampleWells.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__